import editIcon from '@/features/profiles/components/StudentProfile/assets/edit.svg';
import { getFlagFromTimezone, getTimezoneAbbreviation } from '@/lib/utils';

interface TimezoneWithFlagProps {
  timezone?: string;
  onEditClick: () => void;
}

export const TimezoneWithFlag = ({
  timezone,
  onEditClick,
}: TimezoneWithFlagProps) => {
  if (!timezone) return <></>;
  const flag = getFlagFromTimezone(timezone);
  const abbreviation = getTimezoneAbbreviation(timezone);
  return (
    <div className="flex items-center gap-2">
      <p className="font-medium text-sm leading-[22px] text-magical-moonlight-d1">
        {flag ? <span className="text-lg">{flag} </span> : null}
        All mentioned times are in{' '}
        <span className="font-bold text-magical-moonlight-d2">
          {timezone}
          {abbreviation ? ` (${abbreviation})` : ''}
        </span>
      </p>
      <button
        type="button"
        className="flex items-center justify-center p-1 rounded hover:bg-magical-moonlight-d1/10 transition-colors"
        aria-label="Edit timezone"
        onClick={onEditClick}
      >
        <img src={editIcon} alt="Edit" className="w-5 h-5" />
      </button>
    </div>
  );
};
